import type { CalculationConfig } from '@calculations/types/calculation-config';
import { Decimal } from '@snap-types/types/decimal';

export function calculateUnitPriceFromGrossMargin(
  {
    unitCost,
    grossMargin,
  }: {
    unitCost: Decimal;
    grossMargin: Decimal;
  },
  config: CalculationConfig,
): Decimal {
  if (grossMargin.gte(new Decimal('1'))) {
    throw new Error('grossMargin cannot be greater than or equal to "1"');
  }

  return unitCost
    .dividedBy(new Decimal('1').minus(grossMargin))
    .toDecimalPlaces(config.decimalPlaces);
}

export function calculateGrossMarginFromUnitPrice(
  {
    unitCost,
    unitPrice,
  }: {
    unitCost: Decimal;
    unitPrice: Decimal;
  },
  config: CalculationConfig,
): Decimal {
  if (unitPrice.eq(new Decimal('0'))) {
    throw new Error('unitPrice cannot be "0"');
  }

  return unitPrice
    .minus(unitCost)
    .dividedBy(unitPrice)
    .toDecimalPlaces(config.decimalPlaces);
}
